import React from "react";

const Blogs = () => {
  return (
    <div>
      <section className="border rounded border-success my-4 p-2">
        <h4>1. What is the purpose of react router?</h4>
        <p>
          React Router is a standard library for routing in React. It enables
          the navigation among views of various components in a React
          Application, allows changing the browser URL, and keeps the UI in sync
          with the URL
        </p>
      </section>

      <section className="border rounded border-success my-4 p-2">
        <h4>2. How does context API work?</h4>
        <p>
          The React Context API is a way for a React app to effectively produce
          global variables that can be passed around. This is the alternative to
          "prop drilling" or moving props from grandparent to child to parent,
          and so on. Context is also touted as an easier, lighter approach to
          state management using Redux.
        </p>
      </section>

      <section className="border rounded border-success my-4 p-2">
        <h4>3. What is the usability of useRef</h4>
        <p>
          The useRef Hook allows you to persist values between renders. It can
          be used to store a mutable value that does not cause a re-render when
          updated. It can be used to access a DOM element directly. useRef()
          only returns one item. It returns an Object called current. When we
          initialize useRef we set the initial value: useRef(0). It's like doing
          this: const <code>count = {"{current: 0}"}</code> We can access the
          count by using count.current.
        </p>
      </section>
    </div>
  );
};

export default Blogs;
